'use client';

import Icon from '@/components/ui/AppIcon';

interface UserType {
  id: string;
  label: string;
  icon: string;
  description: string;
}

interface UserTypeSelectorProps {
  userTypes: UserType[];
  selectedType: string;
  onSelect: (typeId: string) => void;
}

export default function UserTypeSelector({
  userTypes,
  selectedType,
  onSelect,
}: UserTypeSelectorProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {userTypes.map((type) => (
        <button
          key={type.id}
          onClick={() => onSelect(type.id)}
          className={`p-6 rounded-lg border-2 transition-all duration-300 text-left ${
            selectedType === type.id
              ? 'border-primary bg-surface shadow-natural-lg'
              : 'border-border bg-card hover:border-secondary hover:shadow-natural'
          }`}
        >
          <div className="flex items-start space-x-4">
            <div
              className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${
                selectedType === type.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-surface text-primary'
              }`}
            >
              <Icon name={type.icon as any} size={24} />
            </div>
            <div className="flex-1">
              <h3 className="font-heading font-semibold text-base text-text-primary mb-1">
                {type.label}
              </h3>
              <p className="text-sm text-text-secondary">{type.description}</p>
            </div>
            <div
              className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                selectedType === type.id
                  ? 'border-primary bg-primary' :'border-border bg-card'
              }`}
            >
              {selectedType === type.id && (
                <Icon name="CheckIcon" size={16} className="text-primary-foreground" />
              )}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}